export default __webpack_public_path__ + "static/media/P-040.290f0c2b.png";